// 如果发送链接
export function isUrl(url = "") {
  return /^(https?:\/\/(([a-zA-Z0-9]+-?)+[a-zA-Z0-9]+\.)+[a-zA-Z]+)(:\d+)?(\/.*)?(\?.*)?(#.*)?$/.test(url);
}

function appendQuery(url, key, value) {
  if (!url || value === undefined || value === null || value === "") {
    return url;
  }

  const hashIndex = url.indexOf("#");
  const hash = hashIndex > -1 ? url.slice(hashIndex) : "";
  const baseUrl = hashIndex > -1 ? url.slice(0, hashIndex) : url;
  const separator = baseUrl.indexOf("?") > -1 ? "&" : "?";

  return `${baseUrl}${separator}${encodeURIComponent(key)}=${encodeURIComponent(value)}${hash}`;
}

export function getCustomerServiceLink(config = {}) {
  if (Number(config.kf_toggle) !== 1 || !config.kf_link) {
    return "";
  }

  return appendQuery(config.kf_link, "client_type", "h5");
}

/**
 * 聊天助手 iframe 地址
 * @param {{ token?: string, uid?: string|number, toUserId?: string|number, channel?: string, groupId?: string|number, baseUrl?: string }} options
 */
export function buildChatAssistantUrl(options = {}) {
  const {
    token = "",
    uid = "",
    toUserId,
    channel = "default",
    groupId,
    baseUrl = "https://new-chat.topvan1.com/",
    // baseUrl = "http://localhost:8080/",
  } = options;

  const params = new URLSearchParams();
  if (token !== undefined && token !== null && token !== "") {
    params.set("token", String(token));
  }
  if (uid !== undefined && uid !== null && uid !== "") {
    params.set("uid", String(uid));
  }
  if (toUserId !== undefined && toUserId !== null && toUserId !== "") {
    params.set("toUserId", String(toUserId));
  }
  if (channel) {
    params.set("channel", String(channel));
  }
  if (groupId !== undefined && groupId !== null && groupId !== "") {
    params.set("groupId", String(groupId));
  }

  const query = params.toString();
  if (!query) return baseUrl;
  const joiner = baseUrl.indexOf("?") > -1 ? "&" : "?";
  return `${baseUrl}${joiner}${query}`;
}
